/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'
import { CardColorProps } from '../BaseIcon'

export const GenericBank: FunctionComponent<CardColorProps> = ({ blackAndWhite = false }) => (
  <React.Fragment>
    {!blackAndWhite && (
      <React.Fragment>
        <rect width='40' height='24' rx='2' fill='white' />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M38 1H2C1.44771 1 1 1.44772 1 2V22C1 22.5523 1.44772 23 2 23H38C38.5523 23 39 22.5523 39 22V2C39 1.44772 38.5523 1 38 1ZM2 0C0.895431 0 0 0.89543 0 2V22C0 23.1046 0.895431 24 2 24H38C39.1046 24 40 23.1046 40 22V2C40 0.895431 39.1046 0 38 0H2Z'
          fill='#F0F0F0'
        />
        <g clipPath='url(#clip0_21414_29509)'>
          <path
            d='M25.5 16.5H25V12.5H24V16.5H22V12.5H21V16.5H19V12.5H18V16.5H16V12.5H15V16.5H14.5C14.224 16.5 14 16.7235 14 17C14 17.2765 14.224 17.5 14.5 17.5H25.5C25.776 17.5 26 17.2765 26 17C26 16.7235 25.776 16.5 25.5 16.5Z'
            fill='black'
          />
          <path
            d='M25.7395 9.06124L20.2395 6.06124C20.09 5.98024 19.91 5.98024 19.7605 6.06124L14.2605 9.06124C14.1 9.14874 14 9.31724 14 9.50024V11.0002C14 11.2767 14.224 11.5002 14.5 11.5002H25.5C25.776 11.5002 26 11.2767 26 11.0002V9.50024C26 9.31724 25.9 9.14874 25.7395 9.06124ZM20 10.0002C19.4475 10.0002 19 9.55274 19 9.00024C19 8.44774 19.4475 8.00024 20 8.00024C20.5525 8.00024 21 8.44774 21 9.00024C21 9.55274 20.5525 10.0002 20 10.0002Z'
            fill='black'
          />
        </g>
        <defs>
          <clipPath id='clip0_21414_29509'>
            <rect width='12' height='12' fill='white' transform='translate(14 6)' />
          </clipPath>
        </defs>
      </React.Fragment>
    )}
    {blackAndWhite && (
      <React.Fragment>
        <rect width='40' height='24' rx='2' fill='white' />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M38 1H2C1.44771 1 1 1.44772 1 2V22C1 22.5523 1.44772 23 2 23H38C38.5523 23 39 22.5523 39 22V2C39 1.44772 38.5523 1 38 1ZM2 0C0.895431 0 0 0.89543 0 2V22C0 23.1046 0.895431 24 2 24H38C39.1046 24 40 23.1046 40 22V2C40 0.895431 39.1046 0 38 0H2Z'
          fill='black'
        />
        <g clipPath='url(#clip0_21414_29510)'>
          <path
            d='M25.5 16.5H25V12.5H24V16.5H22V12.5H21V16.5H19V12.5H18V16.5H16V12.5H15V16.5H14.5C14.224 16.5 14 16.7235 14 17C14 17.2765 14.224 17.5 14.5 17.5H25.5C25.776 17.5 26 17.2765 26 17C26 16.7235 25.776 16.5 25.5 16.5Z'
            fill='black'
          />
          <path
            d='M25.7395 9.06124L20.2395 6.06124C20.09 5.98024 19.91 5.98024 19.7605 6.06124L14.2605 9.06124C14.1 9.14874 14 9.31724 14 9.50024V11.0002C14 11.2767 14.224 11.5002 14.5 11.5002H25.5C25.776 11.5002 26 11.2767 26 11.0002V9.50024C26 9.31724 25.9 9.14874 25.7395 9.06124ZM20 10.0002C19.4475 10.0002 19 9.55274 19 9.00024C19 8.44774 19.4475 8.00024 20 8.00024C20.5525 8.00024 21 8.44774 21 9.00024C21 9.55274 20.5525 10.0002 20 10.0002Z'
            fill='black'
          />
        </g>
        <defs>
          <clipPath id='clip0_21414_29510'>
            <rect width='12' height='12' fill='white' transform='translate(14 6)' />
          </clipPath>
        </defs>
      </React.Fragment>
    )}
  </React.Fragment>
)
